export default __webpack_public_path__ + "static/media/icon-brand-nagad.49a0ca90.svg";